import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debug from './debug';

// Utility to truncate long identifiers (e.g., UUIDs) by keeping a prefix and suffix
// Example: midTruncate('1234567890abcdef', 4, 4) => '1234...cdef'
export function midTruncate(value, start = 6, end = 6) {
  if (!value || typeof value !== 'string') return '';
  if (value.length <= start + end + 3) return value; // no need to truncate
  return `${value.slice(0, start)}...${value.slice(value.length - end)}`;
}

// Inline component for displaying truncated IDs with a copy button.
// Usage: <TruncatedId value={id} start={6} end={6} />

export const TruncatedId = ({ value, start = 6, end = 6, copyLabel = 'Copy', onCopy }) => {
  if (!value) return <span>-</span>;
  const truncated = midTruncate(value, start, end);
  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      if (onCopy) onCopy(value);
    } catch (err) {
      debug.error('Clipboard copy failed', err);
    }
  };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \'Liberation Mono\', monospace' }}>{truncated}</span>
      <button
        type="button"
        aria-label={copyLabel}
        onClick={handleCopy}
        style={{
          cursor: 'pointer',
          background: 'transparent',
            border: 'none',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            color: 'inherit',
            opacity: 0.65
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.65)}
      >
        <FontAwesomeIcon icon={["fad", "copy"]} style={{ fontSize: 10 }} />
      </button>
    </span>
  );
};

export default midTruncate;
